import React, {useEffect, useRef} from "react";
import {Modal} from "@renta-apps/athenaeum-react-components";
import styles from './GetReportModal.module.scss';
import Localizer from "@/localization/Localizer";
import GetReportDownloadSection from "@/pages/ConstructionSiteDetails/EquipmentsNew/GetReportModal/GetReportDownloadSection";
import {ProductWithTelematics} from "@/models/server/Models/Equipment/ProductWithTelematics";
import {ConstructionSiteModel} from "@/models/server/ConstructionSiteModel";

interface GetReportModalProps {
    isOpen: boolean;
    constructionSite: ConstructionSiteModel | null;
    data: ProductWithTelematics[];

    onClose(): void;
}

const GetReportModal: React.FC<GetReportModalProps> = ({isOpen, onClose, constructionSite, data}) => {
    const modalRef = useRef<Modal>(null);

    useEffect(() => {
        if (isOpen) {
            modalRef.current?.openAsync();
        } else {
            modalRef.current?.closeAsync();
        }
    }, [modalRef, isOpen]);

    return (
        isOpen ? (
            <Modal className={styles.modal}
                   title={Localizer.constructionSiteDetailsEquipmentTabGetReportModalTitle}
                   ref={modalRef}
                   id="getReportModal"
                   onClose={async () => onClose()}>
                <div>
                    <div className={styles.introSection}>
                        <div className={styles.primaryText}>
                            {Localizer.constructionSiteDetailsEquipmentTabGetReportModalIntroTitle}
                        </div>
                        <div className={styles.secondaryText}>
                            {Localizer.constructionSiteDetailsEquipmentTabGetReportModalIntroText}
                        </div>
                    </div>
                    <GetReportDownloadSection
                        products={data}
                        constructionSite={constructionSite}
                        modalRef={modalRef}
                    />
                </div>
            </Modal>
        ) : null);
};

export default GetReportModal;